import PropTypes from "prop-types";
import React from "react";
import config from "../../../content/meta/config";
import Item from "./Item";
import { Link } from "gatsby";

const Latest = props => {
  const { posts, theme } = props;

  return (
    <React.Fragment>
      <main className="main">
        <div className="container">
          <div className="row">
            <div className="col-10 offset-1">
              <h2 data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">
                Posts
              </h2>
            </div>
          </div>
          <div className="col-12 col-lg-10 offset-lg-1 text-center">
          {posts.slice(0, config.numofpost).map(post => {
            const {
              node,
              node: {
                fields: { slug }
              }
            } = post;
            return <Item key={slug} post={node} theme={theme} />;
          })}
            <hr />
          </div>
          <div className="col-10 offset-1 text-center">
            <Link to="/post">
              <button className="robo-button">Posts</button>
            </Link>
          </div>
        </div>
      </main>

      {/* --- STYLES --- */}
      <style jsx>{`
        hr {
          width: 100%;
          margin: auto;
          margin-top: 10px;
        }
        .main {
          p {
            font-size: 1.1em;
            line-height: 1.6;
          }
          .robo-button {
            background-color: #009fc5;
            color: white;
            font-size: 30px;
            font-weight: bold;
            padding: 5px 30px;
            border: none;
            position: relative;
            margin-top: 20px;
            margin-bottom: 30px;

            &::before {
              transition: all 0.2s;
              position: absolute;
              display: block;
              content: "";
              width: 100%;
              height: 100%;
              top: 20%;
              left: 10%;
              background: #fdcc0f;
              z-index: -1;
            }

            &:hover::before {
              transform: translate(-20%, 0);
            }

            &:active::before {
              transform: translate(-20%, 20%);
            }
          }
        }
        h2 {
          border-left: none !important;
          position: relative;
          padding-left: 48px;
          margin-bottom: 20px;
          //font-weight: bold;
          font-size: 40px;
          &::before,
          &::after {
            position: absolute;
            display: block;
            content: "";
          }
          &::after {
            width: 28px;
            height: 28px;
            top: 7px;
            left: 0;
            background: #009fc5;
          }
          &::before {
            width: 20px;
            height: 20px;
            top: 22px;
            left: 16px;
            background: #fdcc0f;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

Latest.propTypes = {
  posts: PropTypes.array.isRequired,
  theme: PropTypes.object.isRequired
};

export default Latest;
